<template>
  <div class="detailed-mode-root">
    <DetailedModeHeader
      v-bind:indicatorItem="currentIndicatorItem"
      v-on:click.native="onHeaderClick"
    />
    <div class="content">
      <div class="desktop-actions" v-if="!$isMobile">
        <div v-on:click="onLeftClick">
          <i class="material-icons">chevron_left</i>
        </div>
        <div v-on:click="onRightClick">
          <i class="material-icons">chevron_right</i>
        </div>
      </div>
      <div class="mobile-actions" v-if="$isMobile">
        <div v-on:click="onLeftClick"></div>
        <div v-on:click="onRightClick"></div>
      </div>
      <DetailedModeExplanation
        v-bind:indicatorItem="currentIndicatorItem"
        v-bind:hasPurifier="hasPurifier"
      />
      <DetailedModeChart
        v-bind:indicatorItem="currentIndicatorItem"
        v-bind:indicatorContainerId="indicatorContainerId"
      />
    </div>
  </div>
</template>

<script>
import DetailedModeHeader from './DetailedModeHeader.vue'
import DetailedModeExplanation from './DetailedModeExplanation.vue'
import DetailedModeChart from './DetailedModeChart.vue'

export default {
  name: 'DetailedMode',
  props: [
    'indicatorItems',
    'hasPurifier',
    'initialIndicatorItem',
    'indicatorContainerId'
  ],
  data: function() {
    return {
      currentIndicatorItem: this.initialIndicatorItem
    }
  },
  components: {
    DetailedModeHeader,
    DetailedModeExplanation,
    DetailedModeChart
  },
  methods: {
    onHeaderClick() {
      window.history.back()
    },
    onLeftClick() {
      this.onSwipe('left')
    },
    onRightClick() {
      this.onSwipe('right')
    },
    onSwipe(direction) {
      let currentIndex = this.indicatorItems.findIndex(
        x => x.data.DataType === this.currentIndicatorItem.data.DataType
      )

      if (direction === 'left') {
        currentIndex--
      } else {
        currentIndex++
      }

      if (currentIndex < 0) {
        currentIndex = this.indicatorItems.length - 1
      } else if (currentIndex >= this.indicatorItems.length) {
        currentIndex = 0
      }

      this.currentIndicatorItem = this.indicatorItems[currentIndex]
    }
  }
}
</script>

<style lang="less">
@import '../app.less';

.detailed-mode-root > .content {
  display: flex;
  flex-direction: column;
  align-items: center;

  > .desktop-actions {
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .desktop-media({max-width: 60vw;});
  }

  > .mobile-actions {
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    > div {
      width: 20vw;
      z-index: 100;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DetailedMode.vue